import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=f3dc276c&"
import script from "./Collection.vue?vue&type=script&lang=ts&"
export * from "./Collection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports